(function () {
  'use strict';

  if (window.FellinoraComparisonTableLoaded) {
    return;
  }

  window.FellinoraComparisonTableLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.documentElement.classList.add('fct-js');

  function setRevealDelays(section) {
    var lines = section.querySelectorAll('[data-fct-line]');
    var revealItems = section.querySelectorAll('[data-fct-reveal]');

    lines.forEach(function (line, index) {
      line.style.setProperty('--fct-delay', 130 + index * 115 + 'ms');
    });

    revealItems.forEach(function (item, index) {
      item.style.setProperty('--fct-delay', Math.min(index * 120, 420) + 'ms');
    });
  }

  function initReveal(section) {
    setRevealDelays(section);

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      section.classList.add('fct-is-visible');
      section.querySelectorAll('[data-fct-reveal]').forEach(function (item) {
        item.classList.add('fct-is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('fct-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.16,
      rootMargin: '0px 0px -8% 0px'
    });

    section.querySelectorAll('[data-fct-reveal]').forEach(function (item) {
      observer.observe(item);
    });
  }

  function initSection(section) {
    initReveal(section);
  }

  function init() {
    document.querySelectorAll('[data-fct-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches('[data-fct-section]') ? event.target : event.target.querySelector('[data-fct-section]');

    if (section) {
      initSection(section);
    }
  });
})();
